module.exports = __webpack_public_path__ + "media/images/clinic-abd388bf7215d3d5d2a8f8668086d5e4.svg";